import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AddonSubscriptionDataService {
  private TravelInsurance: any;
  private AddonSubscriptionPayload: any;
  constructor() {}

  setTravelInsurance(item: any) {
    localStorage.setItem('travelInsurance', JSON.stringify(item));
    this.TravelInsurance = item;
  }
  getTravelInsurance() {
    const travelInsurance = localStorage.getItem('travelInsurance');
    return this.TravelInsurance
      ? this.TravelInsurance
      : travelInsurance
      ? travelInsurance
      : null;
  }

  removeTravelInsurance() {
    localStorage.removeItem('travelInsurance');
    this.TravelInsurance = null;
  }

  setAddonSubscription(p) {
    localStorage.setItem('addonSubscriptionPayload', JSON.stringify(p));
    this.AddonSubscriptionPayload = p;
  }
  getAddonSubscription() {
    const AddonSubscriptionPayload = localStorage.getItem(
      'addonSubscriptionPayload'
    );
    return this.AddonSubscriptionPayload
      ? this.AddonSubscriptionPayload
      : AddonSubscriptionPayload
      ? AddonSubscriptionPayload
      : null;
  }
}
